/* eslint-disable @typescript-eslint/naming-convention */
export var KEY_CONSTANTS;
(function (KEY_CONSTANTS) {
    KEY_CONSTANTS[KEY_CONSTANTS["TAB_KEY"] = 9] = "TAB_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["SHIFT_KEY"] = 16] = "SHIFT_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["ALT_KEY"] = 18] = "ALT_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["CTRL_KEY"] = 17] = "CTRL_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["CAPS"] = 20] = "CAPS";
    KEY_CONSTANTS[KEY_CONSTANTS["DELETE"] = 46] = "DELETE";
    KEY_CONSTANTS[KEY_CONSTANTS["BACKSPACE"] = 8] = "BACKSPACE";
    KEY_CONSTANTS[KEY_CONSTANTS["ESC_KEY"] = 27] = "ESC_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["ENTER_KEY"] = 13] = "ENTER_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["SPACE_KEY"] = 32] = "SPACE_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["UP_KEY"] = 38] = "UP_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["DOWN_KEY"] = 40] = "DOWN_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["LEFT_KEY"] = 37] = "LEFT_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["RIGHT_KEY"] = 39] = "RIGHT_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["CMD_LEFT_KEY"] = 91] = "CMD_LEFT_KEY";
    KEY_CONSTANTS[KEY_CONSTANTS["CMD_RIGHT_KEY"] = 93] = "CMD_RIGHT_KEY";
})(KEY_CONSTANTS || (KEY_CONSTANTS = {}));
export var KEY_KEYS_CONSTANTS;
(function (KEY_KEYS_CONSTANTS) {
    KEY_KEYS_CONSTANTS["TAB_KEY"] = "Tab";
    KEY_KEYS_CONSTANTS["SHIFT_KEY"] = "Shift";
    KEY_KEYS_CONSTANTS["ALT_KEY"] = "Alt";
    KEY_KEYS_CONSTANTS["CTRL_KEY"] = "Control";
    KEY_KEYS_CONSTANTS["CAPS"] = "CapsLock";
    KEY_KEYS_CONSTANTS["DELETE"] = "Delete";
    KEY_KEYS_CONSTANTS["BACKSPACE"] = "Backspace";
    KEY_KEYS_CONSTANTS["ESC_KEY"] = "Escape";
    KEY_KEYS_CONSTANTS["ENTER_KEY"] = "Enter";
    KEY_KEYS_CONSTANTS["UP_KEY"] = "ArrowUp";
    KEY_KEYS_CONSTANTS["DOWN_KEY"] = "ArrowDown";
    KEY_KEYS_CONSTANTS["LEFT_KEY"] = "ArrowLeft";
    KEY_KEYS_CONSTANTS["RIGHT_KEY"] = "ArrowRight";
})(KEY_KEYS_CONSTANTS || (KEY_KEYS_CONSTANTS = {}));
export var KEY_CODE_CONSTANTS;
(function (KEY_CODE_CONSTANTS) {
    KEY_CODE_CONSTANTS["SPACE_KEY"] = "Space";
    KEY_CODE_CONSTANTS["CMD_LEFT_KEY"] = "MetaLeft";
    KEY_CODE_CONSTANTS["CMD_RIGHT_KEY"] = "MetaRight";
})(KEY_CODE_CONSTANTS || (KEY_CODE_CONSTANTS = {}));
export const IGNORE_KEYS = [
    KEY_CONSTANTS.TAB_KEY,
    KEY_CONSTANTS.SHIFT_KEY,
    KEY_CONSTANTS.ALT_KEY,
    KEY_CONSTANTS.CTRL_KEY,
    KEY_CONSTANTS.CAPS,
    KEY_CONSTANTS.ESC_KEY,
    KEY_CONSTANTS.CMD_LEFT_KEY,
    KEY_CONSTANTS.CMD_RIGHT_KEY,
    KEY_CONSTANTS.UP_KEY,
    KEY_CONSTANTS.DOWN_KEY,
    KEY_CONSTANTS.LEFT_KEY,
    KEY_CONSTANTS.RIGHT_KEY,
    KEY_CONSTANTS.ENTER_KEY,
];
